module.exports = __webpack_public_path__ + "img/Structures-2-mobile.e067d51b.png";